import md5 from 'md5';
import {
  ErrorWithCode,
  LastFmScrobbleErrors,
  newError,
} from 'web-shared/src/types/errors';
import { err, ok, Result } from 'neverthrow';
import { safeFetch } from 'web-shared/src/lib/fetch';

export const SHARED_SECRET = '2743c377e96ca8ccb2895c3117ca4a74';
export const API_KEY = '2835c32ebf9cabedf871b8c854ecbb74';

export interface LastFmSession {
  name: string;
  key: string;
}

export const initiateLastFmAuth = () => {
  window.open(
    `https://www.last.fm/api/auth/?api_key=${API_KEY}&cb=${window.location.href}`,
    '_blank',
  );
};

export const handleLastFmToken = async (token: string) => {
  const sessionResult = await getLastFmSession(token);

  if (sessionResult.isErr()) {
    return console.error(sessionResult.error);
  }

  if (sessionResult.value) {
    window.localStorage.setItem(
      'lastfm-session',
      JSON.stringify(sessionResult.value.session),
    );

    window.location.search = '';
  }
};

export const loadLastFmSession = (): LastFmSession | undefined => {
  const localItem = window.localStorage.getItem('lastfm-session');

  if (!localItem) {
    return undefined;
  }

  try {
    const parsed = JSON.parse(localItem);

    if (!(parsed && parsed.name && parsed.key)) {
      window.localStorage.removeItem('lastfm-session');
      return undefined;
    }

    return parsed;
  } catch (e) {
    console.error('Failed to parse local lastfm session');
    window.localStorage.removeItem('lastfm-session');

    return undefined;
  }
};

export const getLastFmSession = async (
  token: string,
): Promise<
  Result<{ session: LastFmSession }, ErrorWithCode<LastFmScrobbleErrors>>
> => {
  const params: Record<string, string> = {
    api_key: API_KEY,
    method: 'auth.getSession',
    token,
  };
  const stringParams = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');

  const signature = `${stringParams.replaceAll(/=|&/g, '')}${SHARED_SECRET}`;
  const md5Signature = md5(signature);

  const response = await safeFetch<{ session: LastFmSession }, never>(
    `https://ws.audioscrobbler.com/2.0/?${stringParams}&api_sig=${md5Signature}&format=json`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
  );

  if (response.isErr()) {
    return err(
      newError(
        'LastFMScrobblerTokenError',
        'Failed to send request to LastFM',
        { params, error: response.error },
      ),
    );
  }

  return ok(response.value);
};
